import { render, staticRenderFns } from "./InputSearchMention.vue?vue&type=template&id=74388d2c&scoped=true&"
import script from "./InputSearchMention.vue?vue&type=script&lang=ts&"
export * from "./InputSearchMention.vue?vue&type=script&lang=ts&"
import style0 from "./InputSearchMention.vue?vue&type=style&index=0&id=74388d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74388d2c",
  null
  
)

export default component.exports